import { putMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const COMPLETE_JOB = 'COMPLETE_JOB';
export const COMPLETE_JOB_SUCCESS = 'COMPLETE_JOB_SUCCESS';
export const COMPLETE_JOB_FAILURE = 'COMPLETE_JOB_FAILURE';

// Action Creators
export const fetchCompleteJob = () => ({
  type: COMPLETE_JOB,
});

export const fetchCompleteJobSuccess = (data) => ({
  type: COMPLETE_JOB_SUCCESS,
  payload: data,
});

export const fetchCompleteJobFailure = (error) => ({
  type: COMPLETE_JOB_FAILURE,
  payload: error,
});

// Thunk Function
export const postCompleteJobProviderCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchCompleteJob(data, external));
    try {
      const response = await putMethodWithToken(url.postCompleteJob, data);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchCompleteJobSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchCompleteJobFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchCompleteJobFailure(error.message));
    }
  };
};
